export default __webpack_public_path__ + "static/media/dark4.5233678d.png";